module.exports = __webpack_public_path__ + "img/Logo-17.8df786cd.svg";